import { message } from "antd";
import { ICategoryAddCallback, api } from "./index";
import { openModalTextBox } from "../components/ModalTextBox";
import { lang } from "../context";
import events from "../context/events";
import { ActionFnEnum, ActionType } from "../types";
const Rename: ICategoryAddCallback = (props, isAllow, isTeam) => {
  const { data, setData } = props;

  return [
    {
      children: lang("ctx.rename.title"),
      callbackOrModal: () => {
        openModalTextBox({
          title: lang("ctx.rename.title"),
          value: data.name,
          maxLength: 50,
          onOk: (value, close) => {
            api.categories.rename(data.id, value, isTeam).then((res) => {
              if (res?.data) {
                events.emit("list.check");
                events.emit("changeFolderInfoById", data.id, value);
                const newData: any = {
                  ...data,
                  title: value,
                  name: value
                };
                setData({
                  type: ActionFnEnum.UPDATE,
                  newItem: newData,
                  id: data.id,
                  actionType: ActionType.Folder
                } as any);
                // events.emit("list.removeOrSetData", [newData], "setData");
                message.success(lang("common.success"));
                close();
              } else {
                message.error(res?.status || lang("common.fail"));
              }
            });
            // changeFolderInfoById({
            //     id: data.id,
            //     name: value,
            // }).then((res: any) => {
            //     if (res) {
            //         message.success(lang('common.success'));
            //         setData({
            //             ...data,
            //             name: value,
            //         });
            //     } else {
            //         message.error(lang('common.fail'));
            //     }
            //     close();
            // });
          }
        });
      },
      isAllow,
      type: "rename",
      icon: "pc_yundoc_rename",
      splitCode: 1
    }
  ];
};

export default Rename;
